import { UseLoadingReturn } from "@/hooks/use-loading";
import useUpdate, { UpdateProps } from "@/hooks/use-update";
import { PaymentType, PaymentTypeUpdateInput } from "@/interfaces/payment-type.interface";
import t2payService from "@/services/t2pay.service";

export type Return = {
  update: (props: UpdateProps<PaymentTypeUpdateInput>) => Promise<PaymentType>;
} & UseLoadingReturn;

const useUpdatePaymentType = (): Return => {
  const { isLoading, startLoading, endLoading, loadingIcon, update } = useUpdate<
    PaymentTypeUpdateInput,
    PaymentType
  >({
    operation: (formData, _id) => t2payService.updatePaymentType(formData, _id),
  });

  return { isLoading, startLoading, endLoading, loadingIcon, update };
};

export default useUpdatePaymentType;
